import { IFetchPrivateStatsParams } from 'modules/stats/actions/fetchPrivateStats';

import { ChainsPrivateStatsContext } from './const';

export interface IChainsPrivateStatsProviderProps {
  children: React.ReactNode;
  value: IFetchPrivateStatsParams;
}

export const ChainsPrivateStatsProvider = ({
  children,
  value,
}: IChainsPrivateStatsProviderProps) => {
  return (
    <ChainsPrivateStatsContext.Provider value={value}>
      {children}
    </ChainsPrivateStatsContext.Provider>
  );
};
